module.exports = {
	"7030.common.7030": "7030",
	"7030.common.notifs": "notifications",
	"7030.common.add": "add",
	"7030.common.delete": "delete",
	"7030.common.price": "price",
	"7030.common.save": "save",
	"7030.common.set": "ok",
	"7030.common.cancel": "cancel",
	"7030.common.continue": "continue",
	"7030.common.unitPrice": "$",
	"7030.common.success": "success",
	"7030.common.failed": "unseccess",
	"7030.common.Netsuccess": "payment successfull",
	"7030.common.Netfailed": "payment unsuccessfull",
	"7030.common.successPayment": "Payment Successfull",
	"7030.common.count": "Num",
	"7030.common.all": "All",
	"7030.common.sort": " Sort",
	"7030.common.default": "Defualt",
	"7030.common.select": "Select",
	"7030.common.filter": "Set Filter",
	"7030.common.paymentStatus": "Payment Status",
	"7030.common.sendRequest": "Send",
	"7030.common.saveChanges": "Save Change",
	"7030.common.messages": "Messages",
	"7030.common.transaction": "Transaction",
	"7030.common.income": "Incoming",
	"7030.common.profile": "Profile",
	"7030.common.vitrin": "Vitrin",
	"7030.common.moreInfo": "More",
	"7030.common.charge": "Charge",
	"7030.common.internet": "Internet",
	"7030.common.bill": "Bill",
	"7030.common.cardToCard": "Card to card",
	"7030.common.transform": "Transform",
	"7030.common.charity": "Charity",
	"7030.common.credit": "Cash",
	"7030.common.car": "Car",
	"7030.common.insurance": "Insurance",
	"7030.common.billWithCode": "With Code",
	"7030.common.increase": "Increase credit",
	"7030.common.getWallet": "Withdrawal",
	"7030.common.ticket": "Ticket",
	"7030.common.priceLabel": "Pirce",
	"7030.common.score": "Score",
	"7030.common.pay": "Payment",
	"7030.common.call": "Call",
	"7030.common.dial": "Dial",
	"7030.common.copyCode": "Copy",
	"7030.common.submit": "Ok",
	"7030.common.otpPlaceHolder": "Enter OTP Code",
	"7030.common.otpLabel": "Enter OTP Code",
	"7030.common.yes": "Yes",
	"7030.common.no": "No",
	"7030.common.doYouExite": "Are you sure signout?",
	"7030.common.waiteAMoment": "Please wait...",
	"7030.common.payWithCredit": "Payment by credit",
	"7030.common.bank": "Bank Name",
	"7030.common.increaseCredit": "Increase Credit",
	"7030.common.del": "Are you sure @param?",
	"7030.vitrin.shop": "Shopping",
	"7030.month.January": "January",
	"7030.month.February": "February",
	"7030.month.March": "March",
	"7030.month.April": "April",
	"7030.month.May": "May",
	"7030.month.June": "June",
	"7030.month.July": "July",
	"7030.month.August": "August",
	"7030.month.September": "September",
	"7030.month.October": "October",
	"7030.month.November": "November",
	"7030.month.December": "December",
	"7030.bank.ansar": "Ansar",
	"7030.bank.ayande": "Ayandeh",
	"7030.bank.bpi": "Pasargad",
	"7030.bank.bsi": "Saderat",
	"7030.bank.edbi": "Tosse Saderat",
	"7030.bank.tose_tavon": "Tosse Taavon",
	"7030.bank.sina": "Sina",
	"7030.bank.shahr": "Shahr",
	"7030.bank.day": "Dey",
	"7030.bank.gardeshgari": "Garseshgari",
	"7030.bank.hekmat": "Hekmat Iranian",
	"7030.bank.iranZamin": "Iran Zamin",
	"7030.bank.khavarmiyaneh": "Khavarmiyaneh",
	"7030.bank.kowsar": "Koasr",
	"7030.bank.mehr": "Mehr",
	"7030.bank.melal": "Mellal",
	"7030.bank.resalat": "Resalat",
	"7030.bank.enovin": "Eghtesad Novin",
	"7030.bank.ghavamin": "Ghavvamin",
	"7030.bank.karafarin": "Karafarin",
	"7030.bank.keshavarzi": "Keshavarzi",
	"7030.bank.maskan": "Maskan",
	"7030.bank.mebank": "Mehr Eghtesad",
	"7030.bank.mellat": "Mellat",
	"7030.bank.melli": "Melli",
	"7030.bank.parsian": "Parsian",
	"7030.bank.post": "Post Bank",
	"7030.bank.refah": "Refah",
	"7030.bank.saman": "Saman",
	"7030.bank.bim": "Sanat Madan",
	"7030.bank.sarmaye": "Sarmayeh",
	"7030.bank.sepah": "Sepah",
	"7030.bank.tejarat": "Tejarat",
	"7030.bank.unknown": "Unknown",
	"7030.user.wellcome": "Wellcom to 7030",
	"7030.user.enterPhoneNum": "Phone number",
	"7030.user.enterPhone": "Phone number",
	"7030.user.phoneNumHolder": "0912xxxxx89",
	"7030.user.isInvite": "Are you invited?",
	"7030.user.ppPerfix": " I accept",
	"7030.user.ppSuffix": " 7030. ",
	"7030.user.pp": " privacy policy ",
	"7030.user.verifying": "Your info are verifying",
	"7030.user.verified": "Your identity are verified",
	"7030.user.rejected": "Your identity are not verified",
	"7030.user.unverified": "Your identity is not verified",
	"7030.user.missingDocumnets":
		"Your identity is not verified because lack of all documents",
	"7030.user.banned": "Access denied",
	"7030.user.addAReferId": "Enter invite code!",
	"7030.transaction.title": "Transaction",
	"7030.income.title": "Income",
	"7030.internetPackage.title": "Internet package",
	"7030.internetPackage.detailes": "info",
	"7030.charge.title": "Buy charging and internet",
	"7030.charge.direct": "Charge direct",
	"7030.charge.internet": "Internet",
	"7030.charge.my": "My charging",
	"7030.charge.code": "Charge Code",
	"7030.charge.package": "Package Name",
	"7030.charge.internetPackage": "Internet package",
	"7030.charge.normal": "Normal",
	"7030.charge.ladies": "Women",
	"7030.charge.young": "Youngs",
	"7030.charge.amazing": "Amazing",
	"7030.charge.postpaidbill": "Postpaid Bill",
	"7030.charge.createFaveNum": "New Number",
	"7030.charge.addCredit": "Increase credit (@param are low)",
	"7030.income.invite": "Invite friend",
	"7030.income.myIds": "My Refer Code",
	"7030.income.withdrawl": "Withdrawal",
	"7030.income.withdrawlFrom7030": "Harvest from account of 7030",
	"7030.income.dailyProfits": "Daily profits",
	"7030.income.dailyProfit": "Daily profit",
	"7030.income.payTo": "Deposit to account",
	"7030.income.byMe": "By myself",
	"7030.common.allIncome": "Total income:",
	"7030.common.todayIncome": "Today income:",
	"7030.inquiry.search": "Inquiry",
	"7030.inquiry.searchWithCode": "Pay with identifier",
	"7030.inquiry.bill": "Receipt inquiry",
	"7030.inquiry.waterBill": "Bill of water",
	"7030.inquiry.electricityBill": "Bill of electrice",
	"7030.inquiry.gasBill": "Bill of gas",
	"7030.inquiry.phoneBill": "Bill of phone",
	"7030.inquiry.mobileBill": "Bill of mobile",
	"7030.inquiry.list": "Bill",
	"7030.inquiry.billCode": "Identifier",
	"7030.inquiry.payment": "Pay with identifier",
	"7030.inquiry.my": "My bills",
	"7030.inquiry.water": "Water",
	"7030.inquiry.electricity": "Electricity",
	"7030.inquiry.accountCode": "ئubscription code",
	"7030.inquiry.gas": "Gas",
	"7030.inquiry.mobile": "Mobile",
	"7030.inquiry.phone": "Landline phone",
	"7030.inquiry.landline": "Landline phone",
	"7030.inquiry.inquiry": "Debt inquiry",
	"7030.inquiry.inquiryCar": "Inquiry",
	"7030.inquiry.myCars": "My cars",
	"7030.inquiry.listCar": "Car list",
	"7030.inquiry.technicalInspection": "Technical visit of car",
	"7030.inquiry.drivingAccident": "Driving Accident",
	"7030.inquiry.ticketsBill": "Car violation",
	"7030.inquiry.technicalInspectionDesc": "Enter VIN and view car violation",
	"7030.inquiry.drivingAccidentDesc": "Enter VIN and view driving accident",
	"7030.inquiry.negativeScoreDesc":
		"Enter driving license and view your negative score",
	"7030.inquiry.car": "Car",
	"7030.inquiry.motor": "Motor",
	"7030.inquiry.vinHolder": "VIN Number",
	"7030.inquiry.certificateHolder": "Driving Licence Number",
	"7030.inquiry.vinNum": "VIN",
	"7030.inquiry.certificateNum": "Licence Number",
	"7030.inquiry.status": "Status",
	"7030.inquiry.expireDate": "Exprice Date",
	"7030.inquiry.negativeScore": "Negative Score",
	"7030.inquiry.offenseCount": "Offense count",
	"7030.inquiry.province": "Province",
	"7030.inquiry.location": "Location of accident",
	"7030.inquiry.accidentType": "Accident Type",
	"7030.inquiry.accidentCulprit": "Culprit",
	"7030.inquiry.plateNum": "Plate number of car",
	"7030.inquiry.station": "Station",
	"7030.inquiry.ticketsDesc": "Enter barcode back of card of car",
	"7030.inquiry.ticketBarCode": "Barcode of card of car",
	"7030.inquiry.municipality": "Municipality",
	"7030.inquiry.tax": "Tax",
	"7030.inquiry.ticket": "Driving tips fine",
	"7030.inquiry.unknown": "unknown",
	"7030.inquiry.tickets": "Car violation",
	"7030.inquiry.waterDesc": "Enter your @param, view inquiry result",
	"7030.inquiry.billCodeHolder": "Enter bill identifier",
	"7030.inquiry.accountCodeHolder": "Enter subscription code",
	"7030.inquiry.billPaymentHolder": "Enter pay Identifier",
	"7030.inquiry.mobileHolder": "Mobile number",
	"7030.inquiry.IdDesc": "Enter bill indentifier and pay identifier.",
	"7030.inquiry.phoneHolder": "phone number",
	"7030.inquiry.ticketHolder": "Number back of card of car",
	"7030.inquiry.billId": "Bill Identifier",
	"7030.inquiry.paymentId": "Pay Identifier",
	"7030.inquiry.myBills": "My Bills",
	"7030.inquiry.mobileTitle": "Mobile Number",
	"7030.inquiry.phoneTitle": "Landline Number",
	"7030.inquiry.BillTitle": "Bills",
	"7030.inquiry.phoneAndMobile": "Mobile & Landline",
	"7030.bill.city": "City",
	"7030.bill.deliveryType": "Type of fine",
	"7030.bill.location": "Location",
	"7030.bill.date": "Date",
	"7030.bill.desc": "Description",
	"7030.bill.address": "Address",
	"7030.bill.ownerName": "owner",
	"7030.bill.persianDate": "Date of payment",
	"7030.bill.previousDate": "Date of reading",
	"7030.bill.addBillTitle": "New Bill",
	"7030.bill.selectCategory": "Select Category",
	"7030.bill.selectBillType": "Select type of bill",
	"7030.bill.dillId": "Bill Identifier",
	"7030.bill.billInputTitle": "Subject (Optional)",
	"7030.bill.ExHome": "example: Home",
	"7030.bill.delBillId": "Are you sure remove @param?",
	/* materials */
	"7030.mobile": "Mobile",
	"7030.mobileDescription": "Mobile Number",
	"7030.tarabord": "Transfer",
	"7030.chargeType": "Charge Type",
	"7030.chargeAmount": "Charge Price",
	"7030.chargeAmountDescription": "Price ($)",
	"7030.buy": "buy",
	"7030.thousands": " $",
	"7030.one": "1000",
	"7030.two": "2000",
	"7030.five": "5000",
	"7030.ten": "10000",
	"7030.twenty": "20000",
	"7030.fifty": "50000",
	"7030.normalCharge": "Normal",
	"7030.irancelSpec": "Amazing",
	"7030.postPaidSim": "Postpaid Sim card",
	"7030.simType": "Sim card type",
	"7030.save": "Save",
	"7030.data": "Data",
	"7030.prePaid": "Prepaid",
	"7030.postPaid": "postpaid",
	"7030.TD-LTE": "TD-LTE",
	"7030.searchInternetPack": "Search",
	"7030.operator": "Operator",
	"7030.mci": "MCI",
	"7030.irancell": "Irancell",
	"7030.rightel": "Rightel",
	"7030.shatel": "Shatel",
	"7030.tci": "TCI",
	"7030.seeAll": "See All",
	"7030.frequently": "Favorite",
	"7030.recentlyPaid": "Recently payment",
	"7030.hezar": "1000 $",
	"7030.date": "10 شهریور 17:47",
	"7030.transaction.transactionType": "Transaction type",
	"7030.transaction.desc": "Transaction description",
	"7030.transaction.datetime": "Transaction Datetime",
	"7030.transaction.identifier": "Identifier",
	"7030.transaction.price": "Price",
	"7030.transaction.sourceCard": "Source Card",
	"7030.transaction.receiverName": "Receiver Name",
	"7030.transaction.destinationCard": "Target Card",
	"7030.transaction.chargeType": "Charge Type",
	"7030.transaction.phoneNumber": "Phone Number",
	"7030.transaction.code": "Barcode",
	"7030.transaction.billCode": "Bill identifier",
	"7030.transaction.billPaymentCode": "Payment Identifier",
	"7030.transaction.airlineNum": "Flight number",
	"7030.transaction.flyDatetime": "Flight DateTime",
	"7030.transaction.source": "Origin of flight",
	"7030.transaction.destination": "Flight destination",
	"7030.transaction.airlineName": "Airline",
	"7030.transaction.passengerName": "Passenger",
	"7030.transaction.addFave": "Add To Fave",
	"7030.transaction.repeat": "Again",
	"7030.transaction.share": "Share",
	"7030.transaction.downloadTicket": "Download",
	"7030.incoming.invite": "Invite",
	"7030.incoming.myInvite": "My guests",
	"7030.incoming.invitessLen": "Guest Count",
	"7030.incoming.invitessAll": "Total guests:",
	"7030.incoming.invitessWeekly": "New guest (a week ago): ",
	"7030.incoming.friendInvite": "Invite friend",
	"7030.incoming.invitessCount": "Invited Friends Count: ",
	"7030.incoming.registerCount": "Registered Friends Count: ",
	"7030.incoming.deleteCount": "Deleted Identifiers Count: ",
	"7030.incoming.person": "People",
	"7030.incoming.latestInvitess": "Latest Guests",
	"7030.incoming.referIDsCount": "Number of IDs",
	"7030.incoming.myReferIDs": "My IDs",
	"7030.incoming.createReferCode": "New ID",
	"7030.incoming.createInviteCodeDesc":
		"با ساخت شناسه دعوت اختصاصی از ویژگی ارسال دعوتنامه برای دوستان استفاده کن و درآمدت رو افزایش بده",
	"7030.incoming.saveInviteCode": "Check and create ID",
	"7030.incoming.lawInviteCode": "Privacy of new ID",
	"7030.incoming.minChar": "Max length 5 character",
	"7030.incoming.combineAlpahAndNum": "Combine number and alphabet",
	"7030.incoming.invitation": "The invitation",
	"7030.incoming.invitationDesc":
		"شناسه دعوت خود را انتخاب کنید و پس از نوشتن متن دعوت، روی ادامه کلیک کنید.",
	"7030.incoming.selectInvitation": "Select",
	"7030.incoming.bodyTextInvitation": "Content",
	"7030.incoming.bodyTextInvitationHolder": "Content of invitation",
	"7030.incoming.sendSMSInvitation": "Send SMS",
	"7030.incoming.delRefer": "Remove ID",
	"7030.incoming.delReferID": "Are you sure remove ID: @param?",
	"7030.incoming.delReferIDDesc":
		"با حذف شناسه، مدعوین آن به شماره تلفن همراه شما منتقل میشود و در صورتیکه توسط کاربر دیگری رزرو شود، نمیتوانید دوباره ثبت کنید",
	"7030.incoming.myInvitees": "My guests",
	"7030.incomming.selectIban": "Ibans",
	"7030.incomming.withdrawlAmount": "price",
	"7030.incomming.enterWithdrawl": "Price",
	"7030.incomming.amountForWithdrawl": "The amount payable",
	"7030.incomming.withdrawTitle": "برداشت درآمد",
	"7030.incomming.sendInvitation": "Send Invitation",
	"7030.incomming.makeReferId": "New ID",
	"7030.incomming.IdEx": "example: ir_7030",
	"7030.incomming.referId": "Identifier",
	"7030.incomming.income": "درآمد",
	"7030.incomming.invited": "Guest",
	"7030.incoming.id": "ID:",
	"7030.incomming.canWithId": "می‌توانید با شناسه معرف",
	"7030.incomming.invitePeople":
		"دیگران را دعوت کنید تا به زیرمجموعه شما بپوندند.",
	"7030.incomming.oneWeek": "یک هفته",
	"7030.incomming.oneMonth": "یک ماه",
	"7030.incomming.threeMonth": "3 ماه",
	"7030.incomming.sixWeek": "6 ماه",
	"7030.incomming.descInvite":
		"سامانه «هفتاد سی» کاربران را در ۷۰ درصد سود بازار بزرگ محصولات اعتباری از جمله شارژ و بسته های اینترنت و قبض و… شریک می کند. شما رو خرید کسانی که از طریق شما با سایت و اپ ۷۰۳۰ آشنا شده اند، سود مشخص خواهید داشت. \n از طریق لینک زیر در چند ثانیه عضو شوید و شروع به درآمدزائی کنید.\n شناسه‌ی معرف هنگام ثبت نام:",
	"7030.incoming.share": "ارسال لینک دعوت",
	"7030.incoming.shareDesc": "اشتراک‌گذاری در شبکه‌های اجتماعی",
	"7030.incoming.friendInviteDesc": "دعوت مستقیم از طریق شماره تلفن",
	"7030.incoming.checkNum": "بررسی شماره‌ها",
	"7030.incoming.minPriceWithdrawlDesc":
		"متاسفانه درآمد شما جهت برداشت کافی نیست!",
	"7030.incoming.maxPriceWithdrawlDesc": "",
	"7030.incoming.addIban": "شماره شبای جدید",
	"7030.incoming.invitationList": "لیست ارسال دعوتنامه",
	"7030.incoming.registerPendding": "در انتظار تکمیل فرآیند ثبت نام",
	"7030.incoming.registered": "ثبت نام شده",
	"7030.incoming.noInvites": "هنوز کسی به زیر مجموعه ی شما اضافه نشده است.",
	"7030.incoming.noInvitesDesc":
		"از دیگران بخواهید با کد معرف شما در هفتادسی ثبت نام کنند تا زیرمجموعه ی شما قرار بگیرند.",

	"7030.profile.identity": "Authentication",
	"7030.profile.editProfile": "Edit Profile",
	"7030.profile.changePass": "Change Password",
	"7030.profile.createPass": "Create Password",
	"7030.profile.referID": "Referral Invitation ID",
	"7030.profile.aboutUs": "About Us",
	"7030.profile.privacy": "Privacy Policy",
	"7030.profile.faq": "FAQ",
	"7030.profile.contactUs": "Contact Us",
	"7030.profile.singout": "Sign out",
	"7030.profile.startuoIdentity": "شروع احراز هویت",
	"7030.profile.firstname": "نام",
	"7030.profile.lastname": "نام خانوادگی",
	"7030.profile.firstnameEn": "نام لاتین",
	"7030.profile.lastnameEn": "نام خانوادگی لاتین",
	"7030.profile.personalCode": "شماره ملی",
	"7030.profile.personalCodeHolder": "03701234567",
	"7030.profile.mail": "ایمیل",
	"7030.profile.mailHolder": "info@7030.ir",
	"7030.profile.mobile": "تلفن همراه",
	"7030.profile.mobileHolder": "0912123456",
	"7030.profile.iban": "شماره شبا",
	"7030.profile.ibanHolder": "123456789745612358",
	"7030.profile.okAndContinue": "Ok And Continue",
	"7030.profile.editInfo": "ویرایش اطلاعات",
	"7030.profile.connectToSupport": "ارتباط با پشتیبانی",
	"7030.profile.yourReferId": "شناسه دعوت معرف شما:",
	"7030.profile.enterYourReferId": "شناسه معرف خود را وارد کنید",
	"7030.profile.submitReferId": "ثبت شناسه دعوت",
	"7030.profile.referIdTitle": "شناسه دعوت معرف",
	"7030.profile.notEqualNewPass":
		"تکرار رمزعبور جدید با رمزعبور جدید برابر نیست",
	"7030.profile.oldPass": "رمزعبور فعلی",
	"7030.profile.newPass": "رمزعبور جدید",
	"7030.profile.repeatPass": "تکرار رمزعبور جدید",
	"7030.profile.enterAnewPass": "یک رمز جدید برای خود تعیین کنید",
	"7030.profile.repeatNewPass": "برای اطمینان رمز جدید را یکبار دیگر وارد کنید",
	"7030.profile.incorrectOTP": "کد فعالسازی درست وارد نشده است",
	"7030.profile.sendCodeInfo": "یک کد 5 رقمی به شماره @param فرستاده شد.",
	"7030.profile.incorrectRptAndpass": "رمز عبور و تکرار آن یکسان نیستند!",
	"7030.profile.acceptTerms": "سامانه هفتادسی موافق هستم",
	"7030.profile.with": "با",
	"7030.profile.uploadDocs": "بارگذاری تصویر مدارک",
	"7030.profile.editUploadedDocs": "ویرایش تصویر مدارک",
	"7030.profile.confirmMobile": "تایید شماره موبایل",
	"7030.profile.shouldBeYourMobilePhone":
		"*شماره موبایل حتماً باید متعلق به خودتان باشد.",
	"7030.profile.shouldBeYourId": "*شماره ملی حتماً باید متعلق به خودتان باشد.",
	"7030.profile.shouldBeYourIban":
		"*شماره ملی حتماً باید متعلق به خودتان باشد.",
	"7030.profile.toCompeletIDV": "جهت تکمیل مراحل احراز هویت، لطفاً ابتدا",
	"7030.profile.howToTakePhoto": "آموزش روش صحیح عکاسی",
	"7030.profile.readAndClickUpload":
		"را مطالعه کرده و سپس روی گزینه بارگذاری کلیک نمایید.",
	"7030.profile.doIDVandearnMoney": "احراز شوید و حرفه‌ای کسب درآمد کنید!",
	"7030.profile.clickForMreInfo": "برای راهنمایی و اطلاعات بیشتر کلیک کنید",
	"7030.profile.reviewInfo":
		"لطفاًً اطلاعات خود را جهت تایید نهایی بازبینی کنید:",
	"7030.profile.FnameAndLname": " نام و نام خانوادگی:",
	"7030.profile.Nnumber": "شماره ملی:",
	"7030.profile.banckName": "نام بانک:",
	"7030.profile.mobileNumber": "شماره موبایل:",
	"7030.profile.ibanNumber": "شماره شبا:",
	"7030.profile.uploadedImage": "تصویر بارگذاری شده:",
	"7030.profile.acceptRules": "با قوانین و مقررات سامانه هفتادسی موافق هستم.",
	"7030.profile.sentCode": "کدتایید ارسال شده به شماره",
	"7030.profile.enterIt": "را وارد نمایید.",
	"7030.profile.acountCredit": "اعتبار حساب",
	"7030.profile.askYourQuestion":
		"سوال‌های خود را با کارشناسان ما درمیان بگذارید.",
	"7030.profile.callSupport": "تماس با پشتیبانی",
	"7030.text.referId":
		"اگر بدون شناسه دعوت ثبت‌نام کرده‌اید و اکنون قصد دارید با دوست خود کسب درآمد کنید، لازم است ابتدا شناسه دعوت خود را ثبت کنید.",
	"7030.text.referIdNote":
		"* توجه! این شناسه دعوت فقط یکبار قابل ثبت می‌باشد و قابل ویرایش نیست.",
	"7030.text.haveReferId":
		"درحال حاضر مدعو شما شناسه زیر می‌باشد، با استفاده از خدمات هفتادسی هم به خود و هم به معرف خود سود می‌رسانید.",
	"7030.text.transaction": "هنوز تراکنشی انجام نداده‌اید!",
	"7030.messages.title": "پیام‌ها",
	"7030.messages.7030Desc": "پیام‌های اختصاصی از هفتادسی‌",
	"7030.charity.institutions": "مراکز",
	"7030.charity.constantPay": "پرداخت مستمر",
	"7030.charity.my": "نیکوکاری‌های من",
	"7030.charity.500": "500",
	"7030.charity.1000": "1",
	"7030.charity.2000": "2",
	"7030.charity.5000": "5",
	"7030.charity.10000": "10",
	"7030.charity.20000": "20",
	"7030.charity.recurrentPayment":
		"همچنین می‌توانید به @param به صورت مستمر پرداخت کنید.",
	"7030.charity.selectInstitution": "انتخاب مرکز",
	"7030.charity.periodicPay": "دوره پرداخت",
	"7030.charity.daily": "روزانه",
	"7030.charity.weekly": "هفتگی",
	"7030.charity.monthly": "ماهانه",
	"7030.charity.1": "روزانه",
	"7030.charity.7": "هفتگی",
	"7030.charity.30": "ماهانه",
	"7030.charity.day": "روز",
	"7030.charity.week": "هفته",
	"7030.charity.month": "ماه",
	"7030.charity.disable": "غیرفعال",
	"7030.charity.edit": "ویرایش",
	"7030.charity.enablePayment": "فعال‌سازی پرداخت مستمر",
	"7030.charity.fajr": " صبح ",
	"7030.charity.payInOrg": " از اعتبار شما به حساب خیریه واریز خواهد شد.",
	"7030.charity.currentCredit": "اعتبار فعلی برای ",
	"7030.charity.priceOk": " کافی است.",
	"7030.charity.currentNoCredit": "اعتبار فعلی شما ناکافی است.",
	"7030.charity.sendNotifEmptyCredit": "آگاه‌سازی هنگام اتمام اعتبار",
	"7030.charity.sendNotifPayment": "آگاه‌سازی پس از هر پرداخت",
	"7030.charity.readMore": "بیشتر بخوانید...",
	"7030.charity.readLess": "کمتر...",
	"7030.charity.myCharity": "نیکوکاری من",
	"7030.charity.doCharity": "کار نیکو کردن از پر کردن است!",
	"7030.shop.category": "دسته بندی",
	"7030.shop.shops": "فروشگاه",
	"7030.shop.newProduct": "جدیدترین محصولات",
	"7030.shop.product": "محصول",
	"7030.shop.products": "محصولات",
	"7030.shop.color": "رنگ",
	"7030.shop.moreInfo": "مشخصات",
	"7030.shop.finalBuy": "تکمیل خرید",
	"7030.shop.discountCode": "کد تخفیف",
	"7030.shop.sendInCity": "ارسال با پیک (مخصوص تهران)",
	"7030.shop.sendPost": "پست پیشتاز",
	"7030.shop.discountCodeHolder": "کد تخفیف را وارد کنید",
	"7030.shop.selectPostType": "لطفاً یکی از روش‌های زیر را انتخاب نمایید:",
	"7030.shop.setInfo": "لطفاً اطلاعات خود را تکمیل کنید:",
	"7030.shop.discountCodeMistake": "کد تخفیف وارد شده معتبر نیست.",
	"7030.shop.notSelectedColor": "رنگ محصول را انتخاب کنید.",
	"7030.shop.emptyField": "اطلاعات خود را وارد کنید.",
	"7030.shop.prePaymentProduct": "پیش فاکتور خرید کالا",
	"7030.shop.countProduct": "تعداد",
	"7030.shop.shippingCost": "هزینه حمل و نقل",
	"7030.shop.typeOfPost": "شیوه ارسال محصول",
	"7030.shop.postInfo": "اطلاعات ارسال",
	"7030.ticket.airplane": "بلیت هواپیما",
	"7030.ticket.flightIn": "پرواز داخلی",
	"7030.ticket.myTicket": "بلیت‌های من",
	"7030.ticket.roundTrip": "رفت و برگشت",
	"7030.ticket.roundtrip": "رفت و برگشت",
	"7030.ticket.went": "رفت",
	"7030.ticket.oneway": "رفت",
	"7030.ticket.sourceCity": "شهر مبدا",
	"7030.ticket.selectSourceCity": "انتخاب مبدا",
	"7030.ticket.targetCity": "شهر مقصد",
	"7030.ticket.selectTargetCity": "انتخاب مقصد",
	"7030.ticket.dateWent": "تاریخ رفت",
	"7030.ticket.dateRound": "تاریخ برگشت",
	"7030.ticket.dateWent&Round": "تاریخ رفت و برگشت",
	"7030.ticket.countAndTypePassenger": "تعداد و نوع مسافر",
	"7030.ticket.search": "جستجو",
	"7030.ticket.countAndTypePassengerSubject":
		"نوع و تعداد مسافران را انتخاب کنید",
	"7030.ticket.adultPassenger": "مسافر بزرگسال",
	"7030.ticket.adult": "بزرگسال",
	"7030.ticket.up12Age": "12 سال به بالا",
	"7030.ticket.childPassenger": "مسافر کودک",
	"7030.ticket.child": "کودک",
	"7030.ticket.up2Age": "2 تا 12 سال",
	"7030.ticket.infantPassenger": "مسافر نوزاد",
	"7030.ticket.infant": "نوزاد",
	"7030.ticket.low2Age": "زیر 2 سال",
	"7030.ticket.today": "امروز",
	"7030.ticket.fly": "پرواز",
	"7030.ticket.to": "به",
	"7030.ticket.select": "انتخاب بلیت",
	"7030.ticket.fnumber": "شماره پرواز",
	"7030.ticket.passengerInfo": "اطلاعات مسافران",
	"7030.ticket.addPassenger": "افزودن مسافر جدید",
	"7030.ticket.addPassengerDesc": "اطلاعات مسافر رو وارد کنید",
	"7030.ticket.gender": "جنسیت",
	"7030.ticket.man": "مرد",
	"7030.ticket.woman": "زن",
	"7030.ticket.birthday": "تاریخ تولد",
	"7030.ticket.finalTicket": "تایید نهایی خرید",
	"7030.ticket.clock": "ساعت",
	"7030.ticket.time": "زمان پرواز",
	"7030.ticket.showMore": "مشاهده جزئیات",
	"7030.ticket.closeShowMore": "بستن جزئیات",
	"7030.ticket.totalPrice": "مجموع مبلغ قابل پرداخت",
	"7030.ticket.ppPerfix": " با خرید این بلیت تمامی",
	"7030.ticket.ppSuffix": "سامانه هفتادسی را میپذیرم ",
	"7030.ticket.flightInfoPrice": "قیمت پرواز",
	"7030.ticket.flightInfo.0": "اطلاعات پرواز (پرواز رفت)",
	"7030.ticket.flightInfo.1": "اطلاعات پرواز (پرواز برگشت)",
	"7030.ticket.passengerInfo.0": "اطلاعات مسافرین (پرواز رفت)",
	"7030.ticket.passengerInfo.1": "اطلاعات مسافرین (پرواز برگشت)",
	"7030.ticket.notFound": "بلیتی یافت نشد",
	"7030.ticket.maxSelect": "حداکثر انتخاب شما برای مسافر",
	"7030.ticket.done": "می باشد",
	"7030.ticket.type": "نوع بلیت",
	"7030.ticket.capacity": "ظرفیت",
	"7030.ticket.cabinType": "نوع بلیت",
	"7030.ticket.seatClass": "کلاس پرواز",
	"7030.ticket.flightType": "نوع پرواز",
	"7030.ticket.airlineCodeName": "کد هواپیمایی",
	"7030.ticket.airplaneType": "نوع هواپیما",
	"7030.ticket.charter": "چارتر",
	"7030.ticket.system": "سیستمی",
	"7030.ticket.first-class-discounted": "فرست کلاس",
	"7030.ticket.economy-upgradable-to-business": "اکونومی",
	"7030.ticket.business": "بیزینس",
	"7030.ticket.business-discounted": "بیزینس ویژه",
	"7030.ticket.shuffle-service": "سرویس مختلط",
	"7030.ticket.first-class": "فرست کلاس",
	"7030.ticket.conditional-reservation": "قابل رزرو",
	"7030.ticket.business-premium": "پریمیوم",
	"7030.ticket.economy-discounted": "اکونومی ویژه",
	"7030.ticket.economy-discounted-upgradable-to-business": "اکونومی",
	"7030.ticket.first-class-premium": "فرست کلاس",
	"7030.ticket.first-class-supersonic-discontinued": "فرست کلاس",
	"7030.ticket.economy": "اکونومی",
	"7030.ticket.shuttle-service-no-reservation-needed-seat-guaranteed": "شاتل",
	"7030.ticket.economy-premium": "اکونومی",
	"7030.ticket.buyed": "آخرین خریدهای انجام شده:",
	"7030.ticket.orderID": "شماره سفارش",
	"7030.ticket.notBuy": "هنوز بلیتی خریداری نکرده اید!",
	"7030.ticket.notBuyDesc":
		"بلیت های خریداری شده خود را در اینجا مشاهده میکنید.",
	"7030.ticket.dawn": "سحر",
	"7030.ticket.morning": "صبح",
	"7030.ticket.noon": "ظهر",
	"7030.ticket.evening": "عصر",
	"7030.ticket.night": "شب",
	"7030.ticket.flightTime": "ساعت پرواز",
	"7030.ticket.priceUp": "کمترین قیمت",
	"7030.ticket.priceDown": "بیشترین قیمت",
	"7030.ticket.filter": "فیلترها",
	"7030.ticket.resetFilter": "پیش فرض‌ها",

	"7030.startPage.income": "کسب درآمد",
	"7030.startPage.incomeText":
		"با هفتادسی میتونی سود کنی و با دعوت دیگران سودتو بیشتر کنی!",
	"7030.startPage.highSpeed": "خرید پرسرعت",
	"7030.startPage.highSpeedText":
		"با ذخیره تراکنش‌های پرتکرار با یک کلیک خرید کن!",
	"7030.startPage.services": "خدمات بی دردسر",
	"7030.startPage.servicesText":
		"کارای بانکیت، بیمه و خلافی ماشینت و خرید بلیت سفرت رو با هفتادسی راحت انجام بده.",
	"7030.startPage.prev": "قبلی",
	"7030.startPage.next": "بعدی",
	"7030.startPage.close": "بستن",
	"7030.startPage.enterApp": "ورود به اپلیکیشن",
	"7030.emptyState.noChargeSaved": "هنوز شارژ و بسته‌ای ذخیره نکرده‌اید!",
	"7030.emptyState.oneClickToCharge":
		"با ذخیره شارژ و بسته‌های پرتکرار خود با یک کلیک خرید کنید.",
	"7030.emptyState.noBillSaved": "هنوز قبضی ذخیره نکرده‌اید!",
	"7030.login.changeNumber": "تغییر شماره",
	"7030.login.waitAndEnterCode":
		"کمی شکیبا باشید و پس از دریافت، آن را وارد کنید.",
	"7030.login.otpCode": "کد تایید",
	"7030.login.wasSent": "فرستاده شد،",
	"7030.login.codeLength": "رقمی به شماره",
	"7030.login.aCode": "یک کد",
	"7030.login.sendCodeAgain": "ارسال مجدداً کد تایید",
	"7030.login.changePassword": "تغییر رمز عبور",
	"7030.login.newPassword": "رمز عبور جدید",
	"7030.login.repeatPassword": "تکرار رمز عبور",
	"7030.login.submitNewPassword": "ثبت رمز جدید",
	"7030.login.enteredValueIsNotSame": " * مقادیر وارد شده یکسان نیست!",
	"7030.login.enterAgainToMakeSure":
		"برای اطمینان رمز جدید را یک بار دیگر وارد کنید",
	"7030.login.makeANewPassword": "یک رمز جدید برای خود تعیین کنید",
	"7030.login.aFiveDigitsCode": "یک کد 5 رقمی به شماره",
	"7030.login.enterToaccountTitle": "ورود به حساب ",
	"7030.login.enterToaccount": "ورود به حساب کاربری",
	"7030.login.plsEnterYourPassword": "لطفاًً رمز عبور خود را وارد کنید:",
	"7030.login.enterPassWord": "رمز عبور را وارد کنید",
	"7030.login.forgotPassword": "رمز عبور را فراموش کرده‌ام",
	"7030.login.referId": " شناسه معرف",
	"7030.login.ifIntroduced": "اگر توسط شخصی به هفتادسی معرفی شدید،",
	"7030.login.bothGain": "شناسه معرف شخص رو وارد کنید و هر دو امتیاز بگیرید!",
	"7030.login.studyMore": "مطالعه بیشتر",
	"7030.login.enterReferId": "شناسه معرف خود را وارد کنید",
	"7030.login.submitReferId": "ثبت شناسه معرف",
	"7030.login.enterAfter": "بعداً وارد می‌کنم",
};
